import { useState } from "react";
import { Flag } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errorMessage } from "@/lib/api";

export function ReportDialog({ open, onClose, peer, messages }) {
  const [reason, setReason] = useState("");
  const [selected, setSelected] = useState({});
  const [block, setBlock] = useState(false);
  const [busy, setBusy] = useState(false);
  const chosen = messages.filter((m) => selected[m.id] && !m.once && m.text);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/chat/reports", { username: peer.username, reason, block, messages: chosen.map((m) => ({ text: m.text, sent_at: new Date(m.sentAt).toISOString(), from_username: m.mine ? "eu" : peer.username })) });
      toast.success(chosen.length ? `Denúncia enviada com ${chosen.length} mensagem(ns).` : "Denúncia enviada."); onClose(true);
    } catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose(false)}>
      <DialogContent className="w-[calc(100vw-2rem)] max-w-sm rounded-3xl p-5" data-testid="chat-report-dialog">
        <DialogTitle className="flex items-center gap-2"><Flag size={18} /> Denunciar @{peer?.username}</DialogTitle>
        <DialogDescription className="text-xs">A conversa é cifrada de ponta a ponta: a moderação só verá as mensagens que você marcar abaixo. Nada é compartilhado sem sua escolha.</DialogDescription>
        <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={2} maxLength={500} placeholder="Descreva o problema" className="ga-input w-full text-sm" data-testid="chat-report-reason" />
        <div className="max-h-40 space-y-1 overflow-y-auto text-xs" data-testid="chat-report-messages">
          {messages.filter((m) => !m.once && m.text).slice(-30).map((m) => (
            <label key={m.id} className="flex items-start gap-2 rounded-xl p-2" style={{ background: "var(--ga-surface)" }}>
              <input type="checkbox" checked={!!selected[m.id]} onChange={(e) => setSelected({ ...selected, [m.id]: e.target.checked })} data-testid={`chat-report-select-${m.id}`} />
              <span className="min-w-0 flex-1 truncate"><b>{m.mine ? "Eu" : peer.display_name}:</b> {m.text}</span>
            </label>
          ))}
          {!messages.length && <p className="ga-muted">Sem mensagens neste aparelho para compartilhar.</p>}
        </div>
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={block} onChange={(e) => setBlock(e.target.checked)} data-testid="chat-report-block" /> Bloquear também</label>
        <button onClick={submit} disabled={busy || reason.trim().length < 3} className="ga-btn-primary w-full" data-testid="chat-report-submit">{busy ? "Enviando..." : `Enviar denúncia${chosen.length ? ` (${chosen.length})` : ""}`}</button>
      </DialogContent>
    </Dialog>
  );
}
